const a = "_slimSearch_r12a8_1", l = "_small_r12a8_21", s = "_large_r12a8_24", r = {
  slimSearch: a,
  small: l,
  large: s
};
export {
  r as default,
  s as large,
  a as slimSearch,
  l as small
};
//# sourceMappingURL=index.es601.js.map
